import React from 'react';
import { DefaultIconProps } from './types';

const SendByEmail: React.FC<DefaultIconProps> = ({ width = 48, height = 48 }) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="46" height="46" rx="8" fill="white" stroke="black" strokeWidth="2" />
    <path d="M35.5 17L28.4575 22.625C27.2346 23.5238 25.7565 24.0086 24.2387 24.0086C22.721 24.0086 21.2429 23.5238 20.02 22.625L13 17" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default SendByEmail;
